import "./App.css";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { useEffect, useState, lazy, Suspense } from 'react';
import axios from 'axios';
import { getAuth, getIdToken, signInWithCustomToken, onAuthStateChanged } from "firebase/auth";
import { Counter } from "./slices/counter/Counter"
import { Quotes } from "./slices/quotes/Quotes"
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SidePanel from "./components/SidePanel";
import Homepage from "./components/Homepage";
import About from "./components/About";
import CompanyLaunch from "./components/CompanyLaunch";
import Mission from "./components/Mission";
import Products from "./components/Products";
import { Media } from "./slices/media/Media";
import SingleMediaPage from "./slices/media/SingleMediaPage";
import { useDispatch } from "react-redux";
import { addMediaListeners } from "./slices/media/mediaSlice";
import { addReleaseNotesListeners } from "./slices/releaseNotes/releaseNotesSlice";
import { addResourceCollectionListeners } from "./slices/resourceCollection/resourceCollectionSlice";
import { userLoggedIn } from "./slices/currentUser/currentUserSlice";
import { ReleaseNotesPage } from "./slices/releaseNotes/ReleaseNotesPage";
import { EditReleaseNotePage } from "./slices/releaseNotes/EditReleaseNoteForm";
import server_config from './ServerConfiguration';
const fevir_go_server_address = server_config["fevir_go_server_address"];

const GetCompositionByFOI = lazy(() => import("./components/GetCompositionByFOI"));
const GetBundleByFOI = lazy(() => import("./components/GetBundleByFOI"));

const RemoveTrailingSlashAndIndexDotHtml = () => {
  // If the last character of the url is '/'
  if (window.location.pathname.match('/.*/$')) {
    return <Navigate from={window.location.pathname} to={window.location.pathname.replace(/\/+$/, "")} />
  } else if (window.location.pathname.match('/.*/index.html$')) {
    return <Navigate from={window.location.pathname} to={window.location.pathname.replaceAll("/index.html", "")} />
  } else { return null }
}

const RedirectSite = ({ page }) => {
  //window.location.href = page;
  window.location.assign(page);
  return <></>;
};

const getFevirUserPayload = async (idToken, agreetoterms) => {
  if (!agreetoterms) {
    agreetoterms = false;
  }
  let returningdata = false;
  const body = {
    'functionid': "login",
    'idToken': idToken,
    'agreetoterms': agreetoterms,
    'getApiToken': true
  };
  try {
    let resp = await axios({
      method: 'POST',
      //url: server_address + ':' + ports["master_server"] + '/',
      url: fevir_go_server_address,
      timeout: 8000,
      data: body,
    });
    if (resp?.data?.success) {
      let loadedData = resp.data;
      if (!loadedData.displaythetermsofagreement) {    //If the user is signing on for the first time, then display the terms of agreement page
        loadedData.displaythetermsofagreement = false;
      }
      returningdata = {
        userId: loadedData.id,
        name: loadedData.name,
        userPublicDetail: {
          shortbio: loadedData.shortbio,
          affiliations: loadedData.affiliations
        },
        userPrivateDetail: {
          displaythetermsofagreement: loadedData.displaythetermsofagreement,
          termsofuseaccept: loadedData.termsofuseaccept,
          datapersonalagreementaccept: loadedData.datapersonalagreementaccept,
          email: loadedData.email,
          notificationemail: loadedData.notificationemail,
          additionalemail: loadedData.additionalemail,
          status: loadedData.status,
          admin: loadedData.admin,
          apiToken: loadedData.apiToken
        }
      }
    }
  } catch (e) {
    console.log(e);
    returningdata = false;
  }
  return returningdata;
}


/* Made defunct due to AI improvement
const loadCustomToken = async (customToken, setIdTokenState = undefined) => {
  let returningdata;
  try {
    const auth = getAuth();
    await signInWithCustomToken(auth, customToken).then(async (userCredential) => {
      try {
        const { currentUser } = auth;
        await getIdToken(currentUser,  true).then(async (idToken) => {
          returningdata = idToken;
          if (idToken && setIdTokenState) {
            setIdTokenState({ "idToken": idToken, "tokenPresent": true });
          }
        }).catch(e => { console.log(e); });
      } catch (e) { console.log(e); }
    }).catch(e => { console.log(e); }); //.finally((result) => { console.log(result); });
  } catch (e) { console.log(e); }
  return returningdata;
}
*/

const getCustomToken = async (code) => {
  let customToken;
  const node_server_address = server_config["fevir_node_server_address"];
  const body = {
    'functionid': 'retrievessocustomtoken',
    'code': code
  };
  try {
    const resp = await axios({
      method: 'POST',
      url: node_server_address,
      timeout: 10000,
      data: body,
    });
    if (resp?.data?.success) {
      customToken = resp.data.customToken;
    }
  } catch (e) {
    console.log("Error getting custom token:", e);
  }
  return customToken;
}

const processCustomTokenCode = async (code) => {
  window.history.replaceState({}, document.title, window.location.pathname); //Clears the parameters
  if (code) {
    let customToken = await getCustomToken(code);
    if (customToken) {
      try {
        const auth = getAuth();
        await signInWithCustomToken(auth, customToken);
      } catch (error) {
        console.error("Error signing in with custom token:", error);
      }
    } else {
      console.error("Failed to retrieve custom token for the provided code.");
    }
  }
}

const loadUserDataToSlice = async (idToken, dispatch) => {
  if (idToken) {
    let fevirUserPayload = await getFevirUserPayload(idToken, false);
    if (fevirUserPayload) {
        dispatch(userLoggedIn(fevirUserPayload));
    } else {
        console.error("Failed to get user payload from server.");
    }
  }
}

const App = () => {
  const [userLoadingState, setUserLoadingState] = useState(true);
  //const [idTokenState, setIdTokenState] = useState({ "idToken": "", "tokenPresent": false });
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const dispatch = useDispatch();
  const handleFloatingButtonClick = () => {
    setIsPanelOpen(!isPanelOpen);
  };

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      const code = window.location.search.split("customtokencode=")[1]?.split('&')[0];

      if (user) {
        setUserLoadingState(true);
        try {
          const idToken = await getIdToken(user, true);
          //setIdTokenState({ idToken: idToken, tokenPresent: true });
          await loadUserDataToSlice(idToken, dispatch);
        } catch (error) {
          console.error("Error getting ID token or loading user data:", error);
          //setIdTokenState({ idToken: '', tokenPresent: false });
          setUserLoadingState(false);
        }
      } else {
        if (code) {
          setUserLoadingState(true);
          await processCustomTokenCode(code);
        }
        //else {
          //setIdTokenState({ idToken: '', tokenPresent: false });
        //}
        setUserLoadingState(false);
      }
    });

    return () => unsubscribe(); //This is a listener unsubscribe function (and not a user unsubscribe)

  }, [dispatch]);

  return (
    <div className={`App ${isPanelOpen ? 'panel-open' : ''}`} id="appdiv">
      <button className="floating-button" onClick={handleFloatingButtonClick}>📝</button>{/* 📋 */} {/* ✏️ */}
      <SidePanel isOpen={isPanelOpen} />
      <Router>
        <RemoveTrailingSlashAndIndexDotHtml />
        <Navbar userLoadingState={userLoadingState} />
        <div className="pagewrapper">
          <Routes>
            <Route path="" exact element={<Homepage />} />
            <Route path="/mission" exact element={<Mission />} />
            <Route path="/blog" exact element={<Mission />} />
            <Route path="/the-mission-change-of-a-lifetime" exact element={<Mission />} />
            <Route path="/about" exact element={<About />} />
            <Route path="/dynamed-founder-launches-computable-publishing-llc" exact element={<CompanyLaunch />} />
            <Route path="/media" exact element={<>
              <Media />
            </>} />
            <Route path="/media/:itemId" exact element={<>
              <SingleMediaPage />
            </>} />
            <Route path="/releasenotes" exact element={<>
              <ReleaseNotesPage />
            </>} />
            <Route path="/toolnotes/:toolName" exact element={<>
              <ReleaseNotesPage />
            </>} />
            <Route path="/releasenotes/:itemId" exact element={<>
              <EditReleaseNotePage />
            </>} />
            <Route path="/products" exact element={<Products />} />
            <Route path="/ctrr" exact element={<RedirectSite page="https://computablepublishing.us/ctrr/" />} /> {/* ctrr.html */}
            <Route path="/Composition" exact element={<Suspense><GetCompositionByFOI /></Suspense>} />
            <Route path="/getcomposition" exact element={<Suspense><GetCompositionByFOI /></Suspense>} />
            <Route path="/Composition/:foi" exact element={<Suspense><GetCompositionByFOI /></Suspense>} />
            <Route path="/getbundle" exact element={<Suspense><GetBundleByFOI /></Suspense>} />
            <Route path="/Bundle/:foi" exact element={<Suspense><GetBundleByFOI /></Suspense>} />
            <Route path="/counter" exact element={<>
              <Counter />
              <p>
                Edit <code>src/App.tsx</code> and save to reload.
              </p>
              <Quotes />
              <span>
                <span>Learn </span>
                <a
                  className="App-link"
                  href="https://reactjs.org"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  React
                </a>
                <span>, </span>
                <a
                  className="App-link"
                  href="https://redux.js.org"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Redux
                </a>
                <span>, </span>
                <a
                  className="App-link"
                  href="https://redux-toolkit.js.org"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Redux Toolkit
                </a>
                <span>, </span>
                <a
                  className="App-link"
                  href="https://react-redux.js.org"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  React Redux
                </a>
                ,<span> and </span>
                <a
                  className="App-link"
                  href="https://reselect.js.org"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Reselect
                </a>
              </span></>}
            />
            <Route path="*" exact element={<h1>Page Not Found</h1>} />
          </Routes>
        </div>
        <br />
        <Footer />
      </Router>
    </div>
  )
}


addMediaListeners();
addReleaseNotesListeners();
addResourceCollectionListeners();
//addCurrentUserListeners();

export default App